import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { BuildingTable } from "@/features/building/BuildingTable";

export function BuildingIndex() {
  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            label: "Category BizzPass",
            href: "/master-data/category-bizzpass",
          },
        ]}
      />
      <H2>Category BizzPass</H2>
      <BuildingTable />
    </>
  );
}
